/* MRL home hero — sharper banners on big / high-density screens.
   The slider only offers the browser images up to 2000px wide. This adds 2400 / 2880 / 3840px
   options (never larger than the uploaded original), so large monitors stop stretching a 2000px file.
   Small screens are unaffected: the browser still picks the smallest file that fits. Fable 9-17-26 */
(function(){
  function upgrade(){
    document.querySelectorAll('.cbs__img').forEach(function(img){
      var ss = img.getAttribute('srcset');
      if (!ss || / 2880w/.test(ss) || / 2400w/.test(ss)) return;
      var m = ss.match(/(\S+?[?&]width=)2000(\S*)\s+2000w/);
      if (!m) return;
      var nat = parseInt(img.getAttribute('width'), 10) || 0;
      var add = [];
      [2400, 2880, 3840].forEach(function(w){ if (nat >= w) add.push(m[1] + w + m[2] + ' ' + w + 'w'); });
      if (nat > 2000 && add.indexOf(m[1] + nat + m[2] + ' ' + nat + 'w') < 0 && [2400,2880,3840].indexOf(nat) < 0) add.push(m[1] + nat + m[2] + ' ' + nat + 'w');
      if (add.length) img.setAttribute('srcset', ss.replace(/\s+$/, '') + ', ' + add.join(', '));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upgrade); else upgrade();
  window.addEventListener('load', upgrade);
})();
